var React = require('react');

function PhoneLaptop (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M128 64h320v32h64V48a48.1 48.1 0 0 0-47.91-48H111.91A48.1 48.1 0 0 0 64 48v240H16a16 16 0 0 0-16 16v16a64.14 64.14 0 0 0 63.91 64H352v-96H128z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M604 128H420a36 36 0 0 0-36 36v312a36 36 0 0 0 36 36h184a36 36 0 0 0 36-36V164a36 36 0 0 0-36-36zm-28 320H448V192h128z","className":"fa-primary","key":2})]);
}

PhoneLaptop.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = PhoneLaptop;

PhoneLaptop.default = PhoneLaptop;
